import { type FC, useRef } from "react";

interface Props {
    src: string;
}

export const VideoPreview: FC<Props> = ({ src }) => {
    const videoRef = useRef<HTMLVideoElement>(null);

    return (
        <video
            ref={videoRef}
            src={src}
            onClick={() => {
                if(videoRef.current) {
                    void videoRef.current.requestFullscreen();
                }
            }}
            disableRemotePlayback
            className="video-preview"
            muted
            autoPlay
            loop
        />
    );
};
